module.exports = __webpack_public_path__ + "img/fredde.3c867070.jpg";